var _excluded = ["message", "icon", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import ErrorBoundary from "react-error-boundary";
import EmptyStateMessage from "./empty-state-message";
import classNames from "classnames";

var MyFallbackComponent = function MyFallbackComponent(_ref) {
  var componentStack = _ref.componentStack,
      error = _ref.error,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? "Oops, there was a problem." : _ref$message,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? "build" : _ref$icon,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(EmptyStateMessage, {
    className: classNames("et--page-error-boundary", className),
    icon: icon,
    text: message
  });
};

MyFallbackComponent.propTypes = {
  className: PropTypes.string,
  componentStack: PropTypes.string,
  error: PropTypes.string,
  icon: PropTypes.string,
  message: PropTypes.string
};

var ETErrorBoundary = function ETErrorBoundary(_ref2) {
  var message = _ref2.message,
      icon = _ref2.icon,
      className = _ref2.className,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(ErrorBoundary, _extends({
    FallbackComponent: function FallbackComponent() {
      return /*#__PURE__*/React.createElement(MyFallbackComponent, {
        message: message,
        icon: icon,
        className: className
      });
    }
  }, props));
};

ETErrorBoundary.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  message: PropTypes.string
};
export default ETErrorBoundary;